import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import '../../components/css/join_us.css'
import meetingImage from "../../assets/static/meeting/meetings.png";

const MeetingHouseHome = () => {
  return (
    <Container fluid className="bg-custom">
      <Container className="container-padding">
      <Row className="flex-column flex-md-row">
      <Col md={6} className="d-flex align-items-start order-md-1">
        <div className="images">
          <img src={meetingImage} alt="Sample" className="img-fluid" />
        </div>
      </Col>
      <Col md={6} className="d-flex align-items-start order-md-2">
        <div className="content">
          <h2>Meeting House Experience</h2>
          <h1>The Choice to community development, and group savings.</h1>
          <p>A Meeting House is a dedicated space where group members—especially in communities or cooperatives—gather to discuss, plan, and make decisions about their financial and social activities.</p>
          <ul className="bullet-points">
            <li><strong>Importance of a Meeting House:</strong></li>
            <li>Community Engagement</li>
            <li>Transparency</li>
            <li>Planning & Strategy</li>
            <li>Training & Education</li>
            <li>Cultural Preservation</li>
          </ul>
          <a href="/meetings">
            <Button className="mt-3 custom-button">Discover more on Meeting House</Button>
          </a>
        </div>
      </Col>
    </Row>
      </Container>
    </Container>
  );
}

export default MeetingHouseHome;
